import { render, staticRenderFns } from "./LesiurpackageItem.vue?vue&type=template&id=2a285f08&scoped=true"
import script from "./LesiurpackageItem.vue?vue&type=script&lang=js"
export * from "./LesiurpackageItem.vue?vue&type=script&lang=js"
import style0 from "./LesiurpackageItem.vue?vue&type=style&index=0&id=2a285f08&prod&scoped=true&lang=css"
import style1 from "./LesiurpackageItem.vue?vue&type=style&index=1&id=2a285f08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a285f08",
  null
  
)

export default component.exports